// extracted by mini-css-extract-plugin
export default {"pageWrapperTemplateContainer":"PageWrapperTemplate_pageWrapperTemplateContainer__Lp2tl","pageBodyWrapper":"PageWrapperTemplate_pageBodyWrapper__VX48U"};